import { ShareUrlData, ShareUrlGenerator } from '@/types';
import { createShortUrl } from '@/utils/http/createShortUrl';
import { getParams } from '@/utils/params';

const defaultGenerateShareUrl: ShareUrlGenerator = (
  { draftId = '', productId = '', viewId = '', productTypeId = '' } = {},
  callback
) => {
  const { locale, platform, shareUrlTemplate } = getParams();
  if (shareUrlTemplate) {
    callback(
      null,
      shareUrlTemplate
        .replace('{PRODUCT_ID}', productId)
        .replace('{DRAFT_ID}', draftId)
        .replace('{VIEW_ID}', viewId)
        .replace('{PRODUCT_TYPE_ID}', productTypeId)
    );
  } else {
    const tld = platform === 'EU' ? 'net' : 'com';
    callback(
      null,
      `https://designer.spreadshirt.${tld}/designers/sketchomat?locale=${locale}&draftId=${draftId}&productTypeId=${productTypeId}&viewId=${viewId}`
    );
  }
};

export interface SharingLinks {
  shortUrl: string;
  url: string;
}

export const generateShareUrl = async (
  data: ShareUrlData,
  shorten?: boolean
): Promise<SharingLinks> => {
  const generateUrl = getParams().generateShareUrl || defaultGenerateShareUrl;
  let shareUrl = await new Promise<string | string[]>((resolve, reject) => {
    generateUrl(data, (err, url) => {
      if (err) {
        return reject(err);
      }

      resolve(url);
    });
  });

  if (Array.isArray(shareUrl)) {
    shareUrl = shareUrl[0];
  }

  if (shorten) {
    try {
      const shortUrl = await createShortUrl(shareUrl);
      return {
        shortUrl,
        url: shareUrl,
      };
    } catch (e) {
      // ignore error and return long url
    }
  }

  return {
    shortUrl: shareUrl,
    url: shareUrl,
  };
};
